import { FaTimes } from "react-icons/fa";

const EditClientModal = ({showEditModal, setShowEditModal, editFormData, setEditFormData, handleEditSubmit}) => {
  if (!showEditModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={() => setShowEditModal(false)} />
      <div className="relative bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="p-4 bg-gradient-to-r from-primary-600 to-cyan-500 text-white flex items-center justify-between">
          <h2 className="text-lg font-bold">Edit User</h2>
          <button onClick={() => setShowEditModal(false)} className="p-2 hover:bg-white/10 rounded-lg"><FaTimes /></button>
        </div>
        <div className="p-6 bg-gray-50 dark:bg-dark-700/50">
          <form onSubmit={handleEditSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-primary-600 dark:text-primary-400 mb-2">Name</label>
              <input
                type="text"
                value={editFormData.name}
                onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
                required
                className="w-full px-4 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-semibold text-primary-600 dark:text-primary-400 mb-2">Email</label>
              <input
                type="email"
                value={editFormData.email}
                onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                required
                className="w-full px-4 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-semibold text-primary-600 dark:text-primary-400 mb-2">Birthdate (Date of Birth)</label>
              <input
                type="date"
                value={editFormData.dateOfBirth || ""}
                onChange={(e) => setEditFormData({ ...editFormData, dateOfBirth: e.target.value })}
                className="w-full px-4 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
            </div>

            <div className="flex justify-end gap-2">
              <button type="button" onClick={() => setShowEditModal(false)} className="px-4 py-2 text-gray-700 dark:text-gray-300 font-medium rounded-xl hover:bg-gray-100 dark:hover:bg-dark-600">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-primary-600 text-white font-medium rounded-xl hover:bg-primary-700">Save Changes</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditClientModal;
